module.exports = __webpack_public_path__ + "img/i_box_01.f2d297bd.svg";